export default __webpack_public_path__ + "static/media/BoostingQualityDate.2582be68.jpg";